import { createContext, useContext } from 'react';
import { WalkmeSdkContextType } from './types';

export const WalkmeSdkContext = createContext<WalkmeSdkContextType>({} as WalkmeSdkContextType);

export const useWalkmeSdkService = () => {
    return useContext<WalkmeSdkContextType>(WalkmeSdkContext);
};
